import Caption from 'LuxKit/Typography/Caption'
import LuxPlusLogoWrapper from 'luxPlus/components/LuxPlusLogoWrapper'
import type { ComponentProps } from 'react'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'
import _PriceRowPrice from '../_PriceRowPrice'
import clsx from 'clsx'

type InheritedBasePriceRowPriceProps = Pick<ComponentProps<typeof _PriceRowPrice>, 'className' | 'discountPercentage' | 'discountType' | 'saleUnit' | 'signDisplay' | 'size' | 'priceFormat' | 'caption'>

interface Props extends InheritedBasePriceRowPriceProps, Utils.PropsWithDataAttributes {
  /**
   * Main price
   */
  memberPrice: number
  /**
   * Prepend the price with the LuxPlus logo
   */
  logoPlacement?: 'leading' | 'trailing'
}

const PriceTrailingCaption = styled(Caption)`
  margin-left: 0.25em;
`

function PriceRowLuxPlusPrice(props: Props) {
  const {
    memberPrice,
    logoPlacement,
    saleUnit,
    size,
    className,
    ...rest
  } = props

  return <_PriceRowPrice
    {...rest}
    className={clsx(className, PriceRowLuxPlusPrice.name)}
    size={size}
    price={memberPrice}
    priceColour="lux-plus"
    saleUnitColour="lux-plus"
    priceLeading={logoPlacement === 'leading' && <><LuxPlusLogoWrapper height={8} />&nbsp;</>}
    saleUnit={saleUnit}
    priceTrailing={logoPlacement === 'trailing' && <PriceTrailingCaption
      as="span"
      variant="medium"
      colour="lux-plus"
      weight="normal"
      format="lowercase"
      wrap="no-wrap"
    >
      <FormattedMessage
        id="pqjEdAUAFgQn-7aQnAgm"
        defaultMessage="with {luxPlusLogo}"
        description="Caption suffix appended after a LuxPlus member price that reads with the LuxPlus logo"
        values={{ luxPlusLogo: <LuxPlusLogoWrapper height={8} /> }}
      />
    </PriceTrailingCaption>}
    wrap={logoPlacement === 'trailing' ? 'word-wrap' : undefined}
  />
}

export default PriceRowLuxPlusPrice
